import React, { useState } from 'react';

const CreatePurchaseStock: React.FC = () => {
    const [stockName, setStockName] = useState('');
    const [quantity, setQuantity] = useState(0);

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        // Handle form submission logic here
        console.log('Stock Name:', stockName);
        console.log('Quantity:', quantity);
    };

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <label htmlFor="stockName">Stock Name:</label>
                <input
                    type="text"
                    id="stockName"
                    value={stockName}
                    onChange={(e) => setStockName(e.target.value)}
                />
            </div>
            <div>
                <label htmlFor="quantity">Quantity:</label>
                <input
                    type="number"
                    id="quantity"
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.valueAsNumber)}
                />
            </div>
            <button type="submit">Create Purchase Stock</button>
        </form>
    );
};

export default CreatePurchaseStock;